<template>
    <Card v-if="isContactUsEnabled" class="quickpay-settings-right-sidebar__contact">
        <CompassAvatarGroup size="extra-large" :avatars="avatars" />
        <div class="quickpay-settings-right-sidebar__contact-content">
            <p
                class="typographies-paragraph-medium-semibold quickpay-settings-right-sidebar__contact-title"
            >
                {{ translations.contactTitle }}
            </p>
            <p
                class="typographies-paragraph-medium-semibold quickpay-settings-right-sidebar__contact-description"
            >
                {{ translations.contactDescription }}
            </p>
            <CompassButton
                :label="translations.contactCta"
                :type="CompassEnums.ButtonType.SECONDARY"
                class="quickpay-settings-right-sidebar__contact-cta"
                leftIcon="message"
                data-intercom-target="CSM Co"
            />
        </div>
    </Card>
    <Card class="quickpay-settings-right-sidebar__faq">
        <div class="quickpay-settings-right-sidebar__faq-thumbnail">
            <img
                src="/ressources/logged/img/illustrations/payment/payment_faq.svg"
                :alt="translations.faqAlt"
            />
        </div>

        <div class="quickpay-settings-right-sidebar__faq-content">
            <div class="quickpay-settings-right-sidebar__faq-header">
                <CompassPill
                    :label="translations.faqLabel"
                    :variant="CompassEnums.PillVariant.PASTEL"
                    :color="CompassEnums.PillColor.PURPLE"
                    :size="CompassEnums.PillSize.EXTRA_SMALL"
                />
                <p
                    class="typographies-paragraph-medium-semibold quickpay-settings-right-sidebar__faq-title"
                >
                    {{ translations.faqTitle }}
                </p>
            </div>
            <div class="quickpay-settings-right-sidebar__faq-footer">
                <CompassLink
                    :label="translations.faqCta"
                    link="https://help.sellsy.com/fr/articles/14034096-paiements-en-ligne-guide-complet"
                    target="blank"
                />
            </div>
        </div>
    </Card>
</template>

<script setup lang="ts">
import Card from 'vcomponents/common/card/Card.vue';
import { computed, inject } from 'vue';
import { Translator } from 'types/injects/translator.type';
import Feature from 'Services/Feature';

const $t = inject('$t') as Translator;

const translations = {
    contactTitle: $t.__('quickpay.QuickpaySettingsRightSidebar.contact.title'),
    contactDescription: $t.__('quickpay.QuickpaySettingsRightSidebar.contact.description'),
    contactCta: $t.__('quickpay.QuickpaySettingsRightSidebar.contact.cta'),
    faqTitle: $t.__('quickpay.QuickpaySettingsRightSidebar.faq.title'),
    faqLabel: $t.__('common.labels.faq'),
    faqCta: $t.__('quickpay.QuickpaySettingsRightSidebar.faq.cta'),
    faqAlt: $t.__('quickpay.QuickpaySettingsRightSidebar.faq.alt'),
};

const avatars = [
    {
        initials: 'S',
        fullName: 'Juliette E',
        photo: '/ressources/logged/img/common/avatars/juliette_e.png',
    },
    {
        initials: 'M',
        fullName: 'Raphaël D',
        photo: '/ressources/logged/img/common/avatars/raphael_d.png',
    },
];

const isContactUsEnabled = computed(() => {
    return Feature.isEnabled('quickpay-contact-us') && Feature.isEnabled('intercom');
});
</script>

<style scoped lang="scss">
.quickpay-settings-right-sidebar {
    &__contact {
        display: flex;
        flex-direction: column;

        @media (width < 1300px) {
            & {
                flex-direction: row;
            }
        }
    }

    @media (width < 1300px) {
        &__contact-content {
            margin-left: var(--spacing-3);
        }
    }

    &__contact-title {
        color: var(--colors-common-text-standard-default);
        margin-top: var(--spacing-2);
        margin-bottom: 0;

        @media (width < 1300px) {
            & {
                margin-top: 0;
            }
        }
    }

    &__contact-description {
        color: var(--colors-common-text-standard-caption);
        margin: 0;
    }

    &__contact-cta {
        margin-top: var(--spacing-2);
        width: 100%;
    }

    &__faq {
        display: flex;
        flex-direction: column;

        @media (width < 1300px) {
            & {
                flex-direction: row;
            }
        }
    }

    &__faq-thumbnail {
        margin-bottom: var(--spacing-2);
        max-width: 100%;
        width: 220px;
        border-radius: var(--spacing-0);

        img {
            max-width: 100%;
        }

        @media (width < 1300px) {
            & {
                margin-bottom: 0;
                flex: 0 0 50%;
                height: 125px;
                overflow: hidden;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    object-position: left;
                }
            }
        }
    }

    @media (width < 1300px) {
        &__faq-content {
            margin-left: var(--spacing-3);
            flex: 1 1 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
    }

    &__faq-title {
        color: var(--colors-common-text-brand-secondary-blue);
    }
}
</style>
